import { atom } from 'jotai';
import { IQuote } from 'types/quote';

const quoteInfoAtom = atom<IQuote>({} as IQuote);
const quoteFileAtom = atom<File[]>([]);
const containerFileAtom = atom<File[][]>([]);

export { quoteInfoAtom, quoteFileAtom, containerFileAtom };